import { render, staticRenderFns } from "./SetupPayment.vue?vue&type=template&id=57bd8d2d&lang=pug"
import script from "./SetupPayment.vue?vue&type=script&lang=js"
export * from "./SetupPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports